export default "__VITE_ASSET__Cwpjbs94__"